import React from 'react';
import PropTypes from 'prop-types';
import { Tab, TabWithButton, IconTab } from './styleTabHorizontal';

const TabHorizontal = ({
  withButtons,
  active,
  className,
  clicked,
  id,
  icon,
  from,
  children
}) => {
  const TabElement = withButtons ? TabWithButton : Tab;
  return (
    <TabElement
      active={active}
      tabIndex="0"
      className={className}
      onClick={clicked}
      id={id}
      withButtons={withButtons}
      from={from}
    >
      {icon && (
        <IconTab svg={icon} size="s" color={active ? 'light' : 'dark'} />
      )}
      {children}
    </TabElement>
  );
};

TabHorizontal.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  }),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  clicked: PropTypes.func.isRequired,
  id: PropTypes.string,
  from: PropTypes.string
};

TabHorizontal.defaultProps = {
  active: false
};

export default TabHorizontal;
